import { Pipe } from '@angular/core';
var SumPipe = (function () {
    function SumPipe() {
    }
    SumPipe.prototype.transform = function (arr) {
        return Array.isArray(arr)
            ? arr.reduce(function (sum, curr) { return sum + curr; }, 0)
            : arr;
    };
    return SumPipe;
}());
export { SumPipe };
SumPipe.decorators = [
    { type: Pipe, args: [{ name: 'sum' },] },
];
/** @nocollapse */
SumPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=sum.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/sum.js
// module id = 245
// module chunks = 4